import { BRAND } from "../brand";
/**
 * Reports, import/export and audit log — English skeleton. Missing keys fall back to Turkish.
 * Import templates and file headers stay Turkish (the import accepts both Turkish and English headers).
 */
export const data = {
  employmentTypes: { full_time: "Full time", part_time: "Part time", intern: "Intern", fixed_term: "Fixed term" },
  statuses: { preboarding: "Starting soon", active: "Active", offboarding: "Leaving", terminated: "Left" },
  units: { day: "days", hour: "hours" },
  noDepartment: "No department",
  noBranch: "No branch",
  import: {
    errors: {
      required: "{column} cannot be empty.",
      invalid_date: "Date not recognised. Use DD.MM.YYYY (15.03.2024) or YYYY-MM-DD.",
      date_in_future: "{column} cannot be in the future.",
      birth_after_start: "Birth date must be before the start date.",
      national_id_format: "Turkish ID number must be 11 digits and not start with 0.",
      national_id_checksum: "Turkish ID number could not be verified; check the digits.",
      national_id_taken: "This ID number is already used by another employee.",
      national_id_duplicate_in_file: "This ID number also appears on row {first}.",
      iban_format: "IBAN must start with TR and be 26 characters (spaces are ignored).",
      iban_checksum: "IBAN check digits do not match; copy the IBAN from the bank again.",
      invalid_email: "Invalid email address.",
      invalid_phone: "Phone number not recognised, e.g. 0532 123 45 67.",
      too_long: "{column} can be at most {max} characters.",
      invalid: "{column} is not valid.",
      duplicate_in_file: "This employee number also appears on row {first}; list each employee once.",
      employee_number_taken: "This employee number is used by another employee.",
      department_not_found: "No department named “{value}”. Add it in settings or retry with “create missing”.",
      branch_not_found: "No branch named “{value}”. Add it in settings or retry with “create missing”.",
      position_not_found: "No position named “{value}”. Add it in settings or retry with “create missing”.",
      manager_not_found: "No manager with employee number {value}. Add the manager to the file or fix the number.",
      manager_self: "An employee cannot be their own manager.",
      manager_terminated: "Manager {value} has left; enter the current manager.",
      manager_cycle: "The reporting line has a loop ({chain}).",
      manager_row_invalid: "The manager's row ({first}) has errors; fix that row first.",
      employment_type_invalid: "Employment type must be Full time, Part time, Intern or Fixed term.",
      employee_not_found: "No employee with this employee number. Import employees first.",
      invalid_number: "Number of days not recognised, e.g. 12 or 12.5.",
      amount_out_of_range: "Days must be between -365 and 365.",
      opening_exists: "An opening balance already exists ({date}). Use a balance adjustment instead.",
      missing_column: "Column “{column}” not found. Use the template headers.",
      duplicate_column: "Column “{column}” appears more than once.",
      no_header: "Header row not found.",
      empty_file: "The file has no rows to import.",
      too_many_rows: "A file can have at most {max} rows; split the file.",
      encoding_unknown: "File encoding not recognised. Save as “CSV UTF-8” or upload .xlsx.",
      unreadable: "The file could not be read. Save it again as .xlsx or “CSV UTF-8”.",
      csv_unterminated_quote: "The CSV has an unclosed quote (\") after row {row}.",
      file_too_complex: "The file is too large or complex.",
      no_leave_type: "There is no annual leave type with a balance.",
      already_imported: "This file was already imported on {date}.",
    },
    warnings: {
      unknown_column: "Column “{column}” was not recognised and will be ignored.",
      encoding_1254: "The file was read as Turkish Windows encoding (Windows-1254). Check Turkish characters in the preview.",
      email_duplicate: "This email is also used by another employee.",
      name_mismatch: "The name on this row does not match the employee ({name}).",
      zero_amount: "Remaining days is 0; nothing will be recorded.",
      employee_terminated: "This employee appears to have left.",
      not_updated: "Employee exists and “update existing” is off; row skipped.",
    },
  },
  audit: {
    system: "System",
    actions: {
      auth: {
        login: "Signed in",
        logout: "Signed out",
        login_failed: "Failed sign-in attempt",
        locked: "Account locked",
      },
      tenant: {
        created: "Company account created",
        suspended: "Company account suspended",
        reactivated: "Company account reopened",
        support_access_changed: `${BRAND.name} support access changed`,
      },
      support: {
        session_started: `${BRAND.name} support session started`,
        session_ended: `${BRAND.name} support session ended`,
        request: "Request in support session",
      },
      platform: {
        login: "Signed in to the admin panel",
        login_failed: "Failed admin panel sign-in",
        logout: "Signed out of the admin panel",
        reauth_failed: "Password confirmation failed",
        user_searched: "Person searched",
        admin_created: "Platform admin created",
        password_set: "Platform admin password set",
        admin_disabled: "Platform admin disabled",
        admin_enabled: "Platform admin enabled",
        sessions_revoked: "Platform admin sessions revoked",
        totp_enabled: "Platform admin two-step verification turned on",
        totp_disabled: "Platform admin two-step verification turned off",
      },
      job: { retried: "Background job retried" },
    },
  },
};
